export default "__VITE_ASSET__DNnY8pax__"